export default "https://statics.cloudfastin.top/static/v1.27.38.2/store/images/new_codedisplay_0_left.png?828e4d0556a9fbca8ab0c6f7a7396c5b";